/* eslint-disable import/no-extraneous-dependencies */
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
// eslint-disable-next-line import/no-extraneous-dependencies
import { withRouter } from 'react-router-dom';
import PaymentInfo from '../../../../components/Web/PaymentInfoRedesign/index';
import * as paymentInfoActions from '../../actions';
import * as cartActions from '../../../../services/Cart/actions';
import cartSaga from '../../../../services/Cart/sagas';
import injectReducer from '../../../../utils/injectReducer';
import injectSaga from '../../../../utils/injectSaga';
import saga from '../../sagas';
import paymentInfo from '../../reducer';
import { checkPlanReferenceData } from '../../../../utils/plansReference';
import taggingSaga from '../../../Common/Tagging.js/sagas';
import * as taggingActions from '../../../Common/Tagging.js/actions';

import * as checkOutActions from '../../../FuncComp/actions';
import checkOutSaga from '../../../FuncComp/sagas';
import getCheckOutDetails from '../../../FuncComp/reducer';

const mapStateToProps = (state) => {
  // const paymentInfoSelector = paymentInfoSelectors.selectData(state);
  // const paymentInfoState = state.get('paymentInfo');
  // getcheckout ->response -> getcheckoutresponse - imple -> retrieve-cart with retrive pay
  // retrieve-cart /retri
  const cartState = state?.checkout;
  const cartDetails = state.cartDetails || {};
  const currentView = state.currentView || {};
  const plansReferenceData = checkPlanReferenceData(state.plansReferenceData);
  const showError = state && state.paymentInfo && state.paymentInfo.errorDetails && state.paymentInfo.errorDetails.showError;
  const ccAttempts = state && state.paymentInfo && state.paymentInfo.errorDetails && (state.paymentInfo.errorDetails.ccAttempts || '');
  const errorMsg = state && state.paymentInfo && state.paymentInfo.showPaymentApiError && state.paymentInfo.showPaymentApiError.notifyErrorMessage;
  const creditReviewSuccessResponse = state.creditCheckDetails?.creditReviewSuccessResponse;
  const showPaymentApiError = state && state.paymentInfo && state.paymentInfo.showPaymentApiError && state.paymentInfo.showPaymentApiError.showError;
  const paymentServiceInfo = state && state.paymentInfo && state.paymentInfo.paymentServiceInfo;
  const sessionValues = state.SessionValues || {};
  const isPostPaymentPaypalError = state.paymentInfo?.isPostPaymentPaypalError;
  const paymentResponseError = state?.paymentPayPalIntermediate?.paymentResponse?.errors?.[0];
  const paymentInfoState = state && state.paymentInfo;
  const paymentError = state?.paymentInfo?.paymentError || false;
  const paymentNtfyMsg = state?.paymentInfo?.paymentNtfyMsg || null;
  const apiLoaded = state.SessionValues?.apiLoaded;

  return {
    // paymentInfoSelector: paymentInfoSelector,
    // paymentInfoState: paymentInfoState
    cartState,
    cartDetails,
    currentView,
    plansReferenceData,
    showError,
    errorMsg,
    creditReviewSuccessResponse,
    ccAttempts,
    showPaymentApiError,
    sessionValues,
    isPostPaymentPaypalError,
    paymentResponseError,
    paymentInfoState,
    paymentServiceInfo,
    paymentError,
    paymentNtfyMsg,
    apiLoaded,
  };
};
function mapDispatchToProps(dispatch) {
  return bindActionCreators({ ...paymentInfoActions, ...cartActions, ...taggingActions, ...checkOutActions }, dispatch);
}
const withReducer = compose(
  injectReducer({ key: 'paymentInfo', reducer: paymentInfo }),
  injectReducer({ key: 'checkout', reducer: getCheckOutDetails }),
);

const withConnect = connect(mapStateToProps, mapDispatchToProps);

const withSaga = compose(
  injectSaga({ key: 'paymentInfo', saga }),
  injectSaga({ key: 'cartDetails', saga: cartSaga }),
  injectSaga({ key: 'taggingDetails', saga: taggingSaga }),
  injectSaga({ key: 'checkoutDetails', saga: checkOutSaga }),
);

export default withRouter(compose(withSaga, withReducer, withConnect)(PaymentInfo));
